import { PropsWithChildren } from "react";
import {
  CartWarehouseStockContext,
  useCartWarehouseStockFetch,
} from "../../hooks/use-cart-warehouse-stock";

export const MMCartWarehouseStockProvider = ({
  children,
}: PropsWithChildren) => {
  const value = useCartWarehouseStockFetch();

  return (
    <CartWarehouseStockContext.Provider value={value}>
      {children}
    </CartWarehouseStockContext.Provider>
  );
};
